import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const actions = {
  REMOVE_SESSION: ({ commit }) => {
    commit('REMOVE_SESSION')
  }
}

const mutations = {
  REMOVE_SESSION: (state) => {
    state.instance = {}
  }
}

export default {
  namespaced: true,
  state: stateAbstract,
  actions: { ...actionsAbstract, ...actions },
  mutations: { ...mutationsAbstract, ...mutations }
}
